// removed by extract-text-webpack-plugin
module.exports = {"react-django-template":"CustomControlWrapper__react-django-template___-hash--base64-5-"};


/*****************
 ** WEBPACK FOOTER
 ** ./src/layouts/CustomControlLayout/CustomControlWrapper.scss
 ** module id = 951
 ** module chunks = 1
 **/